import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/components/products/productCardComponent.scss";
import TextElementComponent from "../../elements/textElements/TextElementComponent";

export const ProductCardComponent = ({ product }) => {
  const navigate = useNavigate();
  const [primaryImageUrl, setPrimaryImageUrl] = useState("");

  useEffect(() => {
    if (product && product.primaryImageId) {
      const imageDetails = product.images.find((image) => image.id === product.primaryImageId);
      if (imageDetails) setPrimaryImageUrl(imageDetails.url);
    } else if (product) {
      setPrimaryImageUrl(product.images[0]?.url);
    }
  }, [product]);

  const navigateToMoreDetails = () => {
    navigate(`/product/${product.id}`);
  };

  return (
    <div className="productCardContainer">
      <div className="productImageContainer">
        <img src={primaryImageUrl} alt={product.productName} />
      </div>
      <div className="productContentContainer">
        <TextElementComponent
          props={{
            tag: "h3",
            text: product.productName,
            maxChars: 80,
          }}
        />
        <h4>{product.price} ₪</h4>
      </div>
      <button className="primaryButton" onClick={navigateToMoreDetails}>
        פרטים נוספים
      </button>
    </div>
  );
};

export default ProductCardComponent;
